module.exports = __webpack_public_path__ + "img/category.2db38bb8.svg";